module.exports = __webpack_public_path__ + "img/fernanda.a3a5e568.png";